export const organizationInterests = [
  {
    id: 1,
    name: 'Diabetes',
    description: null,
    createdAt: '2019-09-09T20:47:40.373Z',
    updatedAt: '2019-09-09T20:47:40.373Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 2,
    name: 'Wellness',
    description: null,
    createdAt: '2019-09-09T20:47:40.372Z',
    updatedAt: '2019-09-09T20:47:40.372Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 3,
    name: 'Obesity',
    description: null,
    createdAt: '2019-09-09T20:47:40.372Z',
    updatedAt: '2019-09-09T20:47:40.372Z',
    createdBy: null,
    updatedBy: null,
  },
];
